import React from 'react';

const PreferencesTooltip = ({ text, backgroundColor }) => (
  <div className="preferences-tooltip" style={{ backgroundColor }}>
    <span style={{ backgroundColor }} />
    {text}
  </div>
);

export default PreferencesTooltip;
